<template>
  <div id="color-page">
    <div class="d-flex justify-end">
      <div class="mx-8 my-4">
        <div class="d-flex justify-end">
          <span class="black--text font-weight-bold" style='font-family:"MS Pゴシック", sans-serif !important; font-size: 11px'>Confidential</span>
        </div>
        <v-img :src="require('@/assets/images/report_header.png')" width="120px" eager></v-img>
      </div>
    </div>
    <div class="ma-10 mt-0" style="height: 930px;">
      <p class="font-weight-bold text-h5">{{naviVisibleList.findIndex(item => item.text === 'RGBオルソ画像') - 1}}. RGBオルソ画像</p>
      <v-img
          style="border: 1px solid black"
          contain
          ref="img"
          eager
          lazy-src="@/assets/images/no-image.png"
          class="image"
          max-height="65%"
          :src="src"
          :key="src"
          @load="doneLoading"
      >
        <template v-slot:placeholder>
          <v-row
              class="fill-height ma-0"
              align="center"
              justify="center"
          >
            <v-progress-circular
                v-if="loadingStatus"
                :size="70"
                :width="7"
                indeterminate
                color="grey lighten-5"
            ></v-progress-circular>
            <v-icon
                v-if="!loadingStatus"
                x-large
                color="red darken-1"
            >
              mdi-alert
            </v-icon>
          </v-row>
        </template>
      </v-img>
      <div class="ma-16 mt-5 mb-0">
        <v-row align-content="center" class="ma-2" v-show="annotation.cell">
          <div style="width: 260px" class="d-flex align-content-center" :class="!annotationTypes['cell'] ? 'disabled' : ''">
            <div class="div-rounded cell ml-5"></div>
            <span class="ml-5">ホットスポット</span>
          </div>
        </v-row>
        <v-row align-content="center" class="ma-2" v-show="annotation.multicell">
          <div style="width: 260px" class="d-flex align-content-center" :class="!annotationTypes['multicell'] ? 'disabled' : ''">
            <div class="div-rounded multicell ml-5"></div>
            <span class="ml-5">マルチホットスポット</span>
          </div>
        </v-row>
        <v-row align-content="center" class="ma-2" v-show="annotation.cluster">
          <div style="width: 260px" class="d-flex align-content-center" :class="!annotationTypes['cluster'] ? 'disabled' : ''">
            <div class="div-rounded cluster ml-5"></div>
            <span class="ml-5">クラスタバイパス</span>
          </div>
        </v-row>
        <v-row align-content="center" class="ma-2" v-show="annotation.module">
          <div style="width: 260px" class="d-flex align-content-center" :class="!annotationTypes['module'] ? 'disabled' : ''">
            <div class="div-rounded module ml-5"></div>
            <span class="ml-5">モジュール異常</span>
          </div>
        </v-row>
        <v-row align-content="center" class="ma-2" v-show="annotation.string">
          <div style="width: 260px" class="d-flex align-content-center" :class="!annotationTypes['string'] ? 'disabled' : ''">
            <div class="div-rounded string ml-5"></div>
            <span class="ml-5">ストリング異常</span>
          </div>
        </v-row>
        <v-row align-content="center" class="ma-2" v-show="annotation.junction">
          <div style="width: 260px" class="d-flex align-content-center" :class="!annotationTypes['junction'] ? 'disabled' : ''">
            <div class="div-rounded junction ml-5"></div>
            <span class="ml-5">ジャンクションボックス過熱</span>
          </div>
        </v-row>
        <v-row align-content="center" class="ma-2" v-show="annotation.pid">
          <div style="width: 260px" class="d-flex align-content-center" :class="!annotationTypes['pid'] ? 'disabled' : ''">
            <div class="div-rounded pid ml-5"></div>
            <span class="ml-5">ＰＩＤ現象の疑い</span>
          </div>
        </v-row>
        <v-row align-content="center" class="ma-2" v-show="annotation.shadow">
          <div style="width: 260px" class="d-flex align-content-center" :class="!annotationTypes['shadow'] ? 'disabled' : ''">
            <div class="div-rounded shadow ml-5"></div>
            <span class="ml-5">影</span>
          </div>
        </v-row>
      </div>
    </div>
    <div class="mr-8">
      <div class="d-flex align-end justify-end">
        <span class="font-weight-bold black--text" style="font-family: 'MS Pゴシック', sans-serif !important; font-size: 12px">‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐</span>
        <span class="font-weight-bold black--text" style="font-family: 'MS Pゴシック', sans-serif !important; font-size: 12px">{{naviVisibleList.findIndex(item => item.text === 'RGBオルソ画像') + 1}}/{{naviVisibleList.length + pdfPageNum + cropImagePageNum + 1}}</span>
      </div>
      <div class="d-flex align-end justify-end">
        <span class="font-weight-bold black--text" style="font-family: 'MS Pゴシック', sans-serif !important; font-size: 11px">Copyright East Engineering Co., Ltd. all rights reserved</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ColorPage",
  props: ['report', 'naviVisibleList', 'cropImagePageNum', 'pdfPageNum', 'filter', 'annotationTypes'],
  data() {
    return {
      src: null,
      folderUuid: this.$route.params.folderUuid,
      loadingStatus: true,
      annotation: {
        'cell': false,
        'multicell': false,
        'cluster': false,
        'module': false,
        'string': false,
        'junction': false,
        'pid': false,
        'shadow': false
      }
    }
  },
  methods: {
    getColorImage(){
      this.src = "";
      if (this.report.color_src){
        this.src = this.report.color_src.concat('?timestamp=' + Date.now());
      }
      else {
        this.loadingStatus = false;
        const navi = this.naviVisibleList.find(item => item.text === 'RGBオルソ画像');
        if (navi){
          navi.visible = false;
        }
        this.doneLoading();
      }
    },
    doneLoading(){
      this.$emit('doneLoadingImage', 'color');
    },
    turnOnAnnotationType(type){
      this.annotation[type] = true;
    },
    updateColorSrc(src){
      this.src = src;
    }
  },
  created() {
    this.getColorImage();
    this.$root.$on('turnOnAnnotationType', this.turnOnAnnotationType);
  },
  mounted() {
    this.$root.$on('updateColorSrc', this.updateColorSrc);
  },
  beforeDestroy() {
    this.$root.$off('turnOnAnnotationType', this.turnOnAnnotationType);
    this.$root.$off('updateColorSrc', this.updateColorSrc);
  }
}
</script>

<style scoped>
span{
  display: inline-flex;
  align-items: center;
}
.div-rounded{
  display: inline-block;
  border: 1px solid #000000;
  border-radius:50%;
  height: 24px;
  width: 24px;
}
.cell{
  background: rgba(255, 109, 0, 1);
}
.multicell{
  background: rgba(255, 255, 0, 1);
}
.cluster{
  background: rgba(213, 0, 0, 1);
}
.string{
  background: rgba(64, 0, 124, 1);
}
.shadow{
  background: rgba(45, 121, 179, 1);
}
.module{
  background: rgba(150, 0, 61, 1);
}
.junction{
  background: rgba(76, 175, 80, 1);
}
.pid{
  background: rgba(27, 94, 32, 1);
}
.disabled{
  opacity: 0.6;
}
</style>
